<!--
// app/components/pages/mercato/simulator/MercatoPlayerSlot.vue
// @component MercatoPlayerSlot - Empty slot placeholder for squad positions
-->
<script setup lang="ts">
type Props = {
  slotNumber: number;
};

const props = defineProps<Props>();

const { $t } = useI18n();
</script>

<template>
  <div class="player-slot" :aria-label="$t('mercatoSimulator.squad.emptySlot')">
    <div class="player-slot__icon">
      <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="16" r="8" stroke="currentColor" stroke-width="2" fill="none" />
        <path
          d="M8 40c0-8.837 7.163-16 16-16s16 7.163 16 16"
          stroke="currentColor"
          stroke-width="2"
          fill="none"
        />
      </svg>
    </div>
    <p class="player-slot__text">{{ $t("general.player.word") }}</p>
  </div>
</template>

<style scoped>
.player-slot {
  @apply bg-gray-900 border-2 border-dashed border-gray-700 rounded-lg p-2 flex flex-col items-center justify-center gap-1 min-h-[90px];
}

.player-slot__icon {
  @apply text-gray-600;
}

.player-slot__text {
  @apply text-xs text-gray-500 uppercase tracking-wide;
}
</style>
